export default "__VITE_ASSET__BWrevA0f__"